import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import Typography from '../Pdf/components/Typography';
import Column from '../Pdf/components/Column';
import theme from '../Pdf/components/theme';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import { PeriodEndReportSectionPageProps } from './types';

const styles = StyleSheet.create({
  container: {
    padding: theme.spacing(
      0,
      theme.spacingSizes.sm,
      theme.spacingSizes.sm,
      theme.spacingSizes.sm,
    ),
  },
});

type Props = PeriodEndReportSectionPageProps & {
  firmName: string;
  vehicleName: string;
};

const Disclaimer: FC<Props> = ({
  firmName,
  vehicleName,
  firmLogoUrl,
  sectionNumber,
  pageNumber,
  totalPages,
}) => {
  return (
    <PeriodEndReportPage
      firmLogoUrl={firmLogoUrl}
      header={`0${sectionNumber} – Disclaimer`}
      pageNumber={pageNumber}
      totalPages={totalPages}
    >
      <Column spacing="sm" style={styles.container}>
        <Typography variant="h5">Disclaimer</Typography>
        <Column spacing="xs">
          <Typography variant="body2">
            The information and material presented in this report is for
            informational purposes only. {firmName} has taken reasonable care to
            ensure that all the information in this report is materially
            accurate and not misleading. No representation or warranty, express
            or implied, is given by or on behalf of {firmName} or {vehicleName}{' '}
            as to the accuracy or completeness of the information contained in
            this report.
          </Typography>
          <Typography variant="body2">
            Valuations are based on third-party data or estimates and may not
            reflect actual exit values. These are illiquid, long-term
            investments. You may not be able to sell or realise their value when
            you want to, and exits are not guaranteed. This update is for
            existing investors only and is not a financial promotion or
            invitation to invest. The contents are confidential and must not be
            shared.
          </Typography>
          <Typography variant="body2">
            Past performance regarding {firmName} or funds under its management
            are not a guide to future performance and may not be repeated. You
            should be aware that share values and income from them may go down
            as well as up and you may not get back all or any of the amount
            originally invested. {firmName} does not provide investment, tax or
            legal advice. If necessary, you should consult an independent
            financial adviser.
          </Typography>
        </Column>
      </Column>
    </PeriodEndReportPage>
  );
};

export default Disclaimer;
